import { style } from "@vanilla-extract/css";
import { vars } from "../../styles";

export const headingStyles = style({
  fontSize: vars.fontSizes.heading.xl,
});

export const linkStyles = style({
  display: "flex",
  flexGrow: 1,
  alignItems: "center",
  justifyContent: "space-between",
  textDecoration: "none",
  color: vars.colors.onSurface,
});

export const iconStyles = style({
  display: "block",
  transition: "transform 0.2s ease-in-out",
  selectors: {
    [`${linkStyles}:hover &`]: {
      transform: "translateX(4px)",
    },
    '[dir="rtl"] &': {
      transform: "scaleX(-1)",
    },
    [`[dir="rtl"] ${linkStyles}:hover &`]: {
      transform: "scaleX(-1) translateX(4px)",
    },
  },
});
